import request from '@/utils/request2'
import qs from 'qs'


//通用查询的订单
export function reportDetailList(data) {
    return request({
        url:  `/cow/subject/report_detail_list`,
        method: 'post',
        data: data
    })
}
//通用查询的订单
export function querySubInfo(data) {
    return request({
        url:  `/cow/subject/query_sub_info?subjectId=${data}`,
        method: 'post',
        data: data
    })
}
//通用查询的订单
export function reportSubject(data) {
    console.log(data)
    return request({
        // url:  `/cow/subject/report-subject`,
        url: `/cow/subject/report-subject?limit=${data.limit}&page=${data.page}&subject=${data.subject}&flag=${data.flag}&startDate=${data.startDate}&endDate=${data.endDate}`,
        method: 'get',
        // data: qs.stringify(data)
    })
}

